import { useState, useRef,useEffect } from 'react';
import { useLazyGetVehicleDetailInformationQuery, useLazyGetVehicleCompPdfListQuery } from '../../../../api/endpoints/vehicleDetailInformation';
import DocumentDownloadService from '../../../../../src/utils/documentDownloadService';

const useVehicleDetail = () => {
    const toast = useRef(null);
    const downloadService = useRef(new DocumentDownloadService(toast));
    const [formData, setFormData] = useState({ chassisNo: '' });
    const [trigger, { data, isFetching, isError }] = useLazyGetVehicleDetailInformationQuery();
    const [triggerPdf, { isFetching: isPdfLoading, data: pdfData }] = useLazyGetVehicleCompPdfListQuery();
     const [hasPdf, setHasPdf] = useState(null);
     const [isDownloadLoading, setIsDownloadLoading] = useState(false);

  const handleFieldChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

    const handleSearch = () => {
        setHasPdf(null);
        if (formData.chassisNo) {
            trigger({ chassisNo: formData.chassisNo });
        }
    };

    
    /**
     * PDF İndirme Fonksiyonu
     */
    const handleDownloadPdf = async (chassisNo, language) => {
        if (!chassisNo || !language) {
            toast.current.show({ severity: 'warn', summary: 'Uyarı', detail: 'Şasi no veya dil bilgisi eksik.', life: 3000 });
            return;
        }

        await downloadService.current.downloadWithTrigger(
            triggerPdf,
            { chassisNo, language },
            { fileName: `${chassisNo}_Document.pdf` },
            {
                responseType: 'json',
                showSuccessToast: true,
                mimeTypeExtractor: () => 'application/pdf',

                dataExtractor: (response) => {
                    console.log('PDF API Ham Yanıtı:', response);

                    const apiPayload = response.data;

                    const innerData = apiPayload?.data;

                    const firstItem = Array.isArray(innerData) ? innerData[0] : null;

                    if (!firstItem?.ev_pdf) {
                        console.error('PDF verisi (ev_pdf) bulunamadı. İncelenen veri:', innerData);
                    }

                    return { content: firstItem?.ev_pdf };
                }
            }
        );
    };
        useEffect(() => {
        const vehicleInfo = data?.data?.vehicleInformation;
        const chassisNo = formData.chassisNo;
        const language = vehicleInfo?.zlangu;

        if (!chassisNo || !language) {
            setHasPdf(null);
            return;
        }
        

        const checkPdf = async () => {
            try {
                const res = await triggerPdf({ chassisNo, language });
                const arr = res?.data?.data;

                const exists = Array.isArray(arr) && arr.length > 0;
                setHasPdf(exists);

                if (!exists) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'PDF bulunamadı',
                        detail: 'Bu araç için PDF dokümanı mevcut değil.',
                        life: 3000
                    });
                }
            } catch {
                setHasPdf(false);
            }
        };

        checkPdf();
    }, [data]);
    return {
        toast,
        formProps: {
            formData,
            onFieldChange: handleFieldChange,
            onSubmit: handleSearch,
            loading: isFetching
        },
        resultProps: {
            data: data?.data || null,
            isLoading: isFetching,
            isError,
            onDownloadPdf: handleDownloadPdf,
            isPdfLoading,
            hasPdf
         
        }
    };
};

export default useVehicleDetail;
